import { render, staticRenderFns } from "./OverwatchCard.vue?vue&type=template&id=ebd7bf48&scoped=true&"
import script from "./OverwatchCard.vue?vue&type=script&lang=js&"
export * from "./OverwatchCard.vue?vue&type=script&lang=js&"
import style0 from "./OverwatchCard.vue?vue&type=style&index=0&id=ebd7bf48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd7bf48",
  null
  
)

export default component.exports